<template lang="pug">
.booking-service(:class='{ "no-top-padding": isMobileApp }')
  .row
    .col-lg-3(v-if='!isMobileApp')
      component(v-bind:is='currentSidebarNav')
    .col-lg-9
      .booking-service-loader(v-if='loading')
        .loader-spinner
      transition(v-else name="fade", mode="out-in")
        component(v-bind:is='currentView' :isMobileApp='isMobileApp' :filter-geography='filterGeography')
</template>

<script>
import { mapGetters, createNamespacedHelpers } from 'vuex'
import DiscoverEventIndex from './discover-event-index.vue'
import DiscoverEventShow from './discover-event-show.vue'
import BeautyClassesIndex from './beauty-classes-index.vue'
import BeautyClassesShow from './beauty-classes-show.vue'
import FindStoreIndex from './find-store-index.vue'
import ServiceCategoryIndex from './service-category-index.vue'
import ServiceCategoryShow from './service-category-show.vue'
import SidebarNavBeautyServices from './SidebarNavBeautyServices.vue'
import SidebarNavStoresAndEvents from './SidebarNavStoresAndEvents.vue'
import StoreLocationShow from './store-location-show.vue'
import StoresAndEventsIndex from './StoresAndEventsIndex.vue'
import StoresAndEventsShow from './StoresAndEventsShow.vue'
import { fullUrl } from '@/modules/services/utilities'
import { dynamicLoadStore } from '@/mixins/store-util'
import { isSsrActivated } from '@/mixins/ssrUtil'
import { getCookie } from '@/modules/services/cookies'
import bookingService from '@/store/modules/booking-service'

const { mapState, mapActions } = createNamespacedHelpers('bookingService')

export default {
  name: 'SephoraBookingService',
  components: {
    DiscoverEventIndex,
    DiscoverEventShow,
    BeautyClassesIndex,
    BeautyClassesShow,
    FindStoreIndex,
    ServiceCategoryIndex,
    ServiceCategoryShow,
    SidebarNavBeautyServices,
    SidebarNavStoresAndEvents,
    StoreLocationShow,
    StoresAndEventsIndex,
    StoresAndEventsShow
  },
  mixins: [
    dynamicLoadStore({ bookingService })
  ],
  props: {
    currentView: {
      type: String,
      required: true
    },
    currentSidebarNav: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      filterGeography: '',
      country: I18n.siteCountryLs
    }
  },
  computed: {
    ...mapGetters(['isMobileApp']),
    ...mapGetters('bookingService', ['storesByCity']),
    ...mapState(['categories', 'loading'])
  },
  beforeRouteEnter (to, from, next) {
    if (to.path.includes('store-location') && !vueSupportBookingServices.supportOnlineReservationSystem) {
      window.location.href = '/store_locations'
    } else {
      if (to.path.includes('store-locations') && to.hash.length > 0) {
        next(vm => vm.setFilterGeography(to.hash.split('#')[1]))
      } else {
        next()
      }
    }
  },
  async mounted () {
    const ssrActivated = await isSsrActivated()
    if (getCookie('jwt-data')) this.$store.dispatch('fetchUser')

    this.fetchCategories().then(() => {
      this.fetchStores().then(() => {
        this.fetchPages().then(() => {
          this.fetchBeautyClasses().then(() => {
            this.fetchEvents().then(() => {
              this.$store.commit('bookingService/setLoading', false)
            })
          })
        })
      })
    }).catch(e => {
      if (ssrActivated) {
        this.$router.push({ path: '/', query: { messageType: 'error', message: this.$t('notifications.bookingServiceNotAvailable') } })
      } else {
        this.$router.push({ path: '/' })
        this.$store.commit('setNotification', {
          type: 'error',
          msg: this.$t('notifications.bookingServiceNotAvailable')
        })
      }
    })
    this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
  },
  methods: {
    ...mapActions([
      'fetchCategories',
      'fetchStores',
      'fetchPages',
      'fetchBeautyClasses',
      'fetchEvents'
    ]),
    setFilterGeography (geo) {
      this.filterGeography = geo
    }
  },
  watch: {
    $route (to, from) {
      if (to.path.includes('store-locations') && to.hash.length > 0) {
        this.setFilterGeography(to.hash.split('#')[1])
      }
    }
  }
}
</script>

<style lang='scss'>
em {
  font-style: italic;
}

.booking-service-loader {
  width: 60%;
  display: flex;
  justify-content: center;

  @include media-breakpoint-down(md) {
    width: 100%;
  }
}

.booking-service {
  padding-top: 15px;

  &.no-top-padding {
    padding-top: 0;
  }
}
</style>

<style lang='scss' scoped>
/deep/ .booking-service-description {
  a {
    @include font-weight-book;
    text-decoration: underline;
    color: $black;
    &:hover {
      color: $brand-primary;
    }
  }

  strong {
    @include font-weight-bold;
  }

  ul {
    li {
      margin-left: 15px;
      list-style: unset;
    }
  }

  ol {
    li {
      margin-left: 15px;
      list-style: unset;
    }
  }
}
</style>
